import React, { useRef, useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Dropdown from 'rc-dropdown';
import { usePageVisibility } from 'hooks/useVisibility';
import { useHistory } from 'react-router-dom';

import { Loader } from 'components/Loader';
import { Icon } from 'components/Icon';
import { ButtonLabel } from 'components/Button';

import { ReservationCard } from './ReservationCard';
import { RangeDatePicker } from './RangeDatePicker';
import 'rc-dropdown/assets/index.css';

const ArchiveReserve = 'ArchiveReserve';
const ActualReserve = 'ActualReserve';

const ReservationColumn = ({
  reserveList,
  limit,
  userOption,
  onScrollColumn,
  stock,
  handleFilterByDate,
  handleFilterIcon,
  handleReserveArchive,
  reserveArchive,
  calendarVisible,
  setCalendarVisible,
}) => {
  const history = useHistory();

  const [_, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();
  const isVisible = usePageVisibility();

  const [hideInfo, setHideInfo] = useState(false);
  useEffect(() => {
    if (isVisible && stock) {
      setHasMore(true);
      setOffset(0);
    }
  }, [isVisible, stock, reserveArchive]);

  const lastRentElementRef = useCallback(
    (node) => {
      if (!reserveList || reserveList.length % limit || !hasMore) {
        return;
      }
      if (observer.current) {
        observer.current.disconnect();
      }
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setOffset((state) => {
            const result = state + limit;
            onScrollColumn({ sub_queries: reserveArchive? ArchiveReserve: ActualReserve, offset: result }).then((data) => {
              setHasMore(data.length === limit);
            });
            return result;
          });
        }
      });
      if (node) {
        observer.current.observe(node);
      }
    },
    [userOption, reserveList]
  );

  const changeHideInfo = () => {
    setHideInfo(!hideInfo);
  };

  const handleAddReserve = () => {
    history.push('/reservation');
  };

  return (
    <>
      <div className="column" style={{ minWidth: '460px', maxWidth: '500px' }}>
        <div className="column-meta">
          <div className="flex-center">
            <ButtonLabel className="column-button--wh" text="Резерв" />
            {!reserveArchive && (
              <ButtonLabel
                className="column-button--wh btn-clickable"
                onClick={handleAddReserve}
                text={<Icon name="add" tooltipText="Добавить резерв" />}
              />
            )}
            {!reserveArchive && (
              <ButtonLabel
                className="column-button--wh btn-clickable-show-hide"
                onClick={changeHideInfo}
                text={
                  hideInfo ? (
                    <Icon name="show" tooltipText="Показать основную информацию" />
                  ) : (
                    <Icon name="hide" tooltipText="Скрыть основную информацию" />
                  )
                }
              />
            )}

            {reserveArchive && (
              <>
                <Dropdown
                  visible={calendarVisible}
                  overlay={
                    <RangeDatePicker handleFilter={handleFilterByDate} close={() => setCalendarVisible(false)} />
                  }
                >
                  <ButtonLabel
                    onClick={() => setCalendarVisible(!calendarVisible)}
                    className="btn-circle"
                    text={<Icon name="calendar" tooltipText="Фильтрация по дате окончания резерва" />}
                  />
                </Dropdown>

                <ButtonLabel
                  className="btn-circle"
                  onClick={() => handleFilterIcon(1)}
                  text={<Icon name="check" tooltipText="Подтверждено" />}
                />

                <ButtonLabel
                  className="btn-circle"
                  onClick={() => handleFilterIcon(-1)}
                  text={<Icon name="cancel" tooltipText="Отклонено" />}
                />

                <ButtonLabel
                  className="btn-circle"
                  onClick={() => handleFilterIcon(-2)}
                  text={<Icon name="viber" tooltipText="Отклонено через Viber" />}
                />

                <ButtonLabel
                  className="btn-circle"
                  onClick={() => handleFilterIcon(2)}
                  text={<Icon name="timer" tooltipText="Просрочено" />}
                />
              </>
            )}
          </div>
          <ButtonLabel
            rounded={true}
            onClick={handleReserveArchive}
            text={reserveArchive ? 'Спрятать архив' : 'Показать архив'}
          />
        </div>

        <div className="column-content scrollable">
          {reserveList &&
            reserveList.map((reserve, index) => {
              const cardRef = reserveList.length === index + 1 ? lastRentElementRef : null;
              return (
                <div key={reserve.actID1C} ref={cardRef}>
                  <ReservationCard
                    key={reserve.actID1C}
                    user={reserve.clientID}
                    reservationId={reserve.actID1C}
                    reserveTerm={reserve.endDateTime}
                    instruments={reserve.chosenItem}
                    comment={reserve.comment}
                    isApproved={reserve.isApproved}
                    bonus={reserve.bonusAccured}
                    isCreatedByClient={reserve.isCreatedByClient}
                    isNotViewed={reserve.isNotViewed}
                    isDeferrer={reserve.isDeferrer}
                    hideInfo={hideInfo}
                    reserveArchive={reserveArchive}
                    userOption={userOption}
                  />
                </div>
              );
            })}

          {reserveList === null && <Loader type="small" color="#000" />}
        </div>
      </div>
    </>
  );
};

ReservationColumn.propTypes = {
  calendarVisible: PropTypes.bool,
  setCalendarVisible: PropTypes.func,
  reserveArchive: PropTypes.bool,
  setReserveArchive: PropTypes.func,
  handleFilterIcon: PropTypes.func.isRequired,
  handleFilterByDate: PropTypes.func.isRequired,
  handleReserveArchive: PropTypes.func.isRequired,
  stock: PropTypes.any,
  reserveList: PropTypes.any,
  limit: PropTypes.number,
  userOption: PropTypes.any,
  onScrollColumn: PropTypes.func.isRequired,
};

export { ReservationColumn };
